<template>
  <component
    :is="patternSvg"
    v-if="patternSvg"
    class="svg-back-pattern"
  />
</template>

<script>
import cube from '@/assets/patterns/cube.svg'
import hexxa from '@/assets/patterns/hexxa.svg'
import pokeball from '@/assets/patterns/pokeball.svg'
import safari from '@/assets/patterns/safari.svg'
import plus from '@/assets/patterns/plus.svg'
import trianglemadness from '@/assets/patterns/trianglemadness.svg'
import wavy from '@/assets/patterns/wavy.svg'
import cubes from '@/assets/patterns/cubes.svg'
import herringbone from '@/assets/patterns/herringbone.svg'
import hexagon from '@/assets/patterns/hexagon.svg'
import jigsaw from '@/assets/patterns/jigsaw.svg'
import maya from '@/assets/patterns/maya.svg'
import onions from '@/assets/patterns/onions.svg'
import scales from '@/assets/patterns/scales.svg'
import stars from '@/assets/patterns/stars.svg'
import orient from '@/assets/patterns/orient.svg'
import greek from '@/assets/patterns/greek.svg'
import xmas from '@/assets/patterns/xmas.svg'
import gwiz from '@/assets/patterns/gwiz.svg'
import cloud from '@/assets/patterns/cloud.svg'
import cogs from '@/assets/patterns/cogs.svg'

export default {
  name: 'TrainerBackPattern',
  components: {
    cube,
    hexxa,
    pokeball,
    safari,
    plus,
    trianglemadness,
    wavy,
    cubes,
    herringbone,
    hexagon,
    jigsaw,
    maya,
    onions,
    scales,
    stars,
    orient,
    greek,
    xmas,
    gwiz,
    cloud,
    cogs,
  },
  props: {
    pattern: String,
  },
  computed: {
    patternSvg() {
      const pattern = this.pattern || this.$store.getters.mergedUserSettings.traineBackPattern
      const options = {
        none: 'div',
        safari: 'safari',
        plus: 'plus',
        trianglemadness: 'trianglemadness',
        wavy: 'wavy',
        cubes: 'cubes',
        herringbone: 'herringbone',
        hexagon: 'hexagon',
        jigsaw: 'jigsaw',
        maya: 'maya',
        // onions: 'onions',
        scales: 'scales',
        stars: 'stars',
        gwiz: 'gwiz',
        hexxa: 'hexxa',
        pokeball: 'pokeball',
        cloud: 'cloud',
        orient: 'orient',
        greek: 'greek',
        cogs: 'cogs',
        xmas: 'xmas',
        cube: 'cube',
      }
      // console.log('pattern', pattern, options[pattern])
      return options[pattern]
    },
  },
}
</script>
<style lang="scss" scoped>
.svg-back-pattern {
  position: absolute;
  height: 100%;
  width: 100%;
  // --clr-svg: var(--clr-trainer_pattern);
  color: var(--clr-trainer_pattern);
}
</style>
